import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [toast, setToast] = useState(null);

  const addToCart = (product, frame) => {
    setCart((prev) => [...prev, { ...product, frame, cartId: Date.now() }]);
    setToast({
      title: 'Added to Collection',
      message: `"${product.title}" with ${frame.name} frame`,
      id: Date.now()
    });
    
    // Auto-dismiss toast
    setTimeout(() => {
      setToast(null);
    }, 4000);
  };

  const clearToast = () => setToast(null);

  return (
    <CartContext.Provider value={{ cart, cartCount: cart.length, addToCart, toast, clearToast }}>
      {children}
    </CartContext.Provider>
  );
};